import { ReactNode } from "react";
import { GradientIcon } from "./GradientIcon";
import { LucideIcon } from "lucide-react";
import { cn } from "@patient-watch/ui/utils";
interface PageLayoutProps {
    title: string;
    description: string;
    icon?: LucideIcon;
    theme: string;
    children: ReactNode;
    className?: string;
    isLoading?: boolean;
}

export function PageLayout({ title, description, icon, theme, children, className, isLoading }: PageLayoutProps) {
    const themes = {
        green: "from-green-600 to-emerald-600",
        blue: "from-blue-600 to-indigo-600",
        purple: "from-purple-600 to-pink-600",
        amber: "from-orange-500 to-yellow-500",
        pink: "from-pink-600 to-rose-600",
    };
    const colors = themes[theme as keyof typeof themes] || themes.green;
    return (
        <div className={`flex flex-col mx-auto py-4 md:py-12 max-w-md ${className}`}>
            <div className="flex flex-col flex-1 justify-center items-center gap-y-8 px-4">
                <div className="relative space-y-4 text-center">
                    <h1 className={cn("bg-clip-text bg-gradient-to-r font-semibold text-transparent text-3xl", colors)}>
                        {title}
                    </h1>
                    <p className="text-slate-600 text-lg">{description}</p>
                </div>

                {icon && <GradientIcon icon={icon} theme={theme} isLoading={isLoading} />}

                <div className="flex flex-col gap-4 pt-4 w-full max-w-md">{children}</div>
            </div>
        </div>
    );
}
